<span class="numeric-input" role="spinbutton" attr.aria-label="{{ value + ' ' + ariaLabel }}" tabindex="0" (keydown)="keydown($event)">
  <input type="hidden" name="{{name}}" value="{{value}}" >
  <span class="numeric-input__value">
    {{ value }}
    <span class="numeric-input__unit" *ngIf="unit">{{ value == 1 ? unit.single : unit.plural }}</span>
  </span>
  <span class="numeric-input__controls">
    <button type="button" class="numeric-input__controls__increase" (click)="increment()" tabindex="-1">
      <span class="icon icon--up-arrow-small"></span>
      <span class="hidden--accessible">Increase</span>
    </button>
    <button type="button" class="numeric-input__controls__decrease" (click)="decrement()" tabindex="-1">
      <span class="icon icon--down-arrow-small"></span>
      <span class="hidden--accessible">Decrease</span>
    </button>
  </span>
</span>